import AppError from '../app-error';

export const getErrorMessage = (error: unknown, fallback: string): string => {
  if (error instanceof AppError) {
    if (error.isServiceUnavailable) {
      return 'Nossos serviços estão temporariamente indisponíveis. Por favor, tente novamente mais tarde.';
    }

    if (error.isUnauthorized) {
      return 'Sua sessão expirou. Por favor, faça login novamente.';
    }

    if (error.isForbidden) {
      return 'Você não tem permissão para realizar esta ação.';
    }

    const messages: Record<string, string> = {
      'cpf-in-use': 'O CPF informado já está em uso.',
      'cart-offer-limit-reached':
        'A quantidade solicitada excede o limite desta oferta.',
      'cart-store-purchase-limit-reached':
        'O limite de compra desta loja foi atingido.',
    };

    return messages[error.code] ?? fallback;
  }

  return fallback;
};
